import React from 'react';
import { Form, Switch, CurrencyBox, TextBox, MaskedBox, UrlBox, EmailBox } from 'fw/forms';
import { Col, Row, Modal, FormGroup, OverlayTrigger, Tooltip as ReactTooltip } from 'react-bootstrap';
import { Box, Label, Button } from 'fw/components'
import { ContentBody } from 'areas/shared/components';
import { PhoneBox } from 'areas/shared/controls'
import * as FormManager from 'fw/forms/form/FormManager';
import * as Notifications from 'fw/globals/Notifications';
import * as API from 'modules/app/API';
import * as Modals from 'fw/globals/Modals';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TooltipCode } from 'areas/shared/consts';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { Currency } from 'fw/components/formatter/Formatter';

class PreQualification extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState();
    }

    initialState = () => {
        return {
            loading: true,
            title: "",
            form: {
                grossRevenue1Year: null,
                grossRevenue1Amount: null,
                grossRevenue2Year: null,
                grossRevenue2Amount: null,
                annualSalesTypeId: null,
                companyName: "",
                companyFEIN: "",
                companyWebsite: "",
                veteranFirstName: "",
                veteranLastName: "",
                mobilePhone: {
					phoneTypeCode: "MOBILE",
					number: "",
					extension: "",
					countryCode: "+1"
				},
                veteranEmail: "",
            },
            showModal: false,
            question: '',
            disabled: true,
            tooltips: null,
            questionnaire: null,
            previousYear: "",
            priorToPreviousYear: "",
            annualSalesTypeList: [],
            fieldStatus: {
                companyNameOk: null,
                companyFEINOk: null,
                companyGrossRevenue1AmountOk: null,
                companyGrossRevenue2AmountOk: null,
                companyWebsiteOk: null,
                veteranFirstNameOk: null,
                veteranLastNameOk: null,
                mobilePhoneOk: null,
                veteranEmailOk: null,
            }
        };
    }

    checkFieldStatus = () => { 
        let form = this.state.form;

        if (!form)
            return;
        
        let companyNameOk = null;
        if (form.companyName && form.companyName.length >= 2)
            companyNameOk = true;
        else if (form.companyName && form.companyName.length > 0)
            companyNameOk = false;
        
        let companyFEINOk = null;
        if (form.companyFEIN && form.companyFEIN.length === 10)
            companyFEINOk = true;
        else if (form.companyFEIN && form.companyFEIN.length > 0)
            companyFEINOk = false;

        let companyGrossRevenue1AmountOk = null;
        let revenue = this.getRevenueNumber(form.grossRevenue1Amount);
        if (revenue && revenue >= 1)
            companyGrossRevenue1AmountOk = true;
        else if (revenue &&revenue < 1)
            companyGrossRevenue1AmountOk = false;

        let companyGrossRevenue2AmountOk = null;
        let revenue2 = this.getRevenueNumber(form.grossRevenue2Amount);
        if (revenue2 && revenue2 >= 1)
            companyGrossRevenue2AmountOk = true;
        else if (revenue2 && revenue2 < 1)
            companyGrossRevenue2AmountOk = false;

        let companyWebsiteOk = null;
        if (form.companyWebsite && form.companyWebsite.length > 0 && this._companyWebsite.validate() === null)
            companyWebsiteOk = true;
        else if (form.companyWebsite && form.companyWebsite.length > 0 && !this._companyWebsite.validate() !== null)
            companyWebsiteOk = false;

        let veteranFirstNameOk = null;
        if (form.veteranFirstName && form.veteranFirstName.length >= 2 && form.veteranFirstName.length <= 30)
            veteranFirstNameOk = true;
        else if (form.veteranFirstName && form.veteranFirstName.length > 0 && (form.veteranFirstName.length < 2 || form.veteranFirstName.length > 30))
            veteranFirstNameOk = false;

        let veteranLastNameOk = null;
        if (form.veteranLastName && form.veteranLastName.length >= 2 && form.veteranLastName.length <= 30)
            veteranLastNameOk = true;
        else if (form.veteranLastName && form.veteranLastName.length > 0 && (form.veteranLastName.length < 2 || form.veteranLastName.length > 30))
            veteranLastNameOk = false;

		let mobilePhoneOk = null;
		if (form.mobilePhone && form.mobilePhone.countryCode === '+1') {
			if (form.mobilePhone.number && form.mobilePhone.number.length === 14)
				mobilePhoneOk = true;
			else if (form.mobilePhone.number && form.mobilePhone.number.length !== 14)
				mobilePhoneOk = false;
		}
		else {
			if (form.mobilePhone && form.mobilePhone.number)
				mobilePhoneOk = true;
			else if (form.mobilePhone && !form.mobilePhone.number)
				mobilePhoneOk = false;
		}

        let veteranEmailOk = null;
        if (form.veteranEmail && form.veteranEmail.length > 0 && this._veteranEmail.validate() === null)
            veteranEmailOk = true;
        else if (form.veteranEmail && form.veteranEmail.length > 0 && !this._veteranEmail.validate() !== null)
            veteranEmailOk = false;
        
        let fieldStatus = {
            companyNameOk: companyNameOk,
            companyFEINOk: companyFEINOk,
            companyGrossRevenue1AmountOk: companyGrossRevenue1AmountOk,
            companyGrossRevenue2AmountOk: companyGrossRevenue2AmountOk,
            companyWebsiteOk: companyWebsiteOk,
            veteranFirstNameOk: veteranFirstNameOk,
            veteranLastNameOk: veteranLastNameOk,
            mobilePhoneOk: mobilePhoneOk,
            veteranEmailOk: veteranEmailOk
        };

        this.setState((prevState) => { 
            return { 
                fieldStatus: fieldStatus
            }; 
        });        
    }

    getSalesTypeId(revenue) {
        if (!this.state.form || !this.state.form.grossRevenue1Amount)
            return null;

        let annualSalesTypeList = this.state.annualSalesTypeList;
        
        let matchingItems = annualSalesTypeList
            .filter(x => (x.grossRevenueLowerBound === null || x.grossRevenueLowerBound <= revenue) && 
                         (x.grossRevenueUpperBound === null || x.grossRevenueUpperBound >= revenue));

        if (matchingItems.length !== 1)
            return null;
        else
            return matchingItems[0].annualSalesTypeId;
    }

    getRevenueNumber(v) {
        let revenue = `${v != null ? v : ""}`;

        // Replace every $ character generated from CurrencyBox
        revenue = revenue
            .replace(/\$/g, '');

        // Replace every comma character generated from CurrencyBox
        revenue = revenue
            .replace(/,/g, '');
        
        // Discard everything efter . character (later discarded at CurrencyBox)
        let n = revenue.indexOf('.');
        revenue = revenue
            .substring(0, n !== -1 ? n : revenue.length);

        return revenue;
    }

    renderFieldStatus(statusOk, invalidTooltipText) {
        let invalidTitle = "Invalid Input";

        if (invalidTooltipText) {
			invalidTitle = invalidTooltipText;
		}

        if (statusOk === true)
        {
            return (
                <FontAwesomeIcon style={{ marginTop: 25, color: "#00a65a" }} icon={faCheck} size="2x" />
            );
        }
        else if (statusOk === false)
        {
            return (
                <React.Fragment>
                    &nbsp;&nbsp;
                    <OverlayTrigger
                        placement="top"
                        rootClose={true}
                        overlay={
                            <ReactTooltip id='tooltip' className="errorTooltipIcon">
                                <div dangerouslySetInnerHTML={{ __html: invalidTitle }} />
                            </ReactTooltip>
                        }>
                        <FontAwesomeIcon style={{ marginTop: 35, color: "#FF0000" }} icon={faTimes} />
                    </OverlayTrigger>
                </React.Fragment>
            );
        }
        else
            return null;
    }

    handleCompanyGrossRevenue1AmountChange = (v) => {
        this.checkFieldStatus();

        if (!this.state.form || !this.state.form.grossRevenue1Amount)
        {
            this._annualSalesTypeId.setValue(null);
            return;
        }

        let revenue = this.getRevenueNumber(this.state.form.grossRevenue1Amount);
        let salesTypeId = this.getSalesTypeId(revenue);
        
        this._annualSalesTypeId.setValue(salesTypeId);
    }

    renderFee() {
        let annualSalesTypeList = this.state.annualSalesTypeList;

        if (this.state.form && this.state.form.annualSalesTypeId)
        {
            let matchingItem = annualSalesTypeList.filter(x => x.annualSalesTypeId === this.state.form.annualSalesTypeId);
            if (matchingItem.length === 1)
            {
                let annualSalesTypeDescription = matchingItem[0].description;
                let preQualificationAmount = matchingItem[0].preQualificationAmount;
                
                return(
                    <React.Fragment>
                        <Row>
                            <Col sm={12}>
                                <h3 style={{ color: '#5592b6' }}>Application Fee</h3>
                                <hr />
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12}>
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>Sales</th>
                                            <th className="text-right">USD</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <b>{annualSalesTypeDescription}</b>
                                            </td>
                                            <td className="text-right">
                                                <b>
                                                    <Currency value={preQualificationAmount}></Currency>
                                                </b>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </Col>
                        </Row>
                    </React.Fragment>
                );
            }
        }
        
        return null;
    }

    setInitialFocus = () => {
        let form = this.state.form;
        let existingCertification = form.certificationId !== 0 && form.certificationId !== null && form.certificationId !== undefined;
        let existingVob = form.vobId !== 0 && form.vobId !== null && form.vobId !== undefined;
        let disabledForm = (existingCertification && form.certificationTypeCode !== "CER") || (!existingCertification && existingVob);

        if (disabledForm)
            this._companyGrossRevenue1Amount && this._companyGrossRevenue1Amount.focus();
        else
            this.companyName && this.companyName.focus();
    }

    componentDidMount() {
        this.get(this.props.match.params.vobKey, this.props.match.params.vobFeinKey, this.props.match.params.vobNameKey);
    }

    updatePostData = (form, dirty) => {
        let revenue = this.getRevenueNumber(form.grossRevenue1Amount);
        form.grossRevenue1Amount = revenue;

        let revenue2 = this.getRevenueNumber(form.grossRevenue2Amount);
        form.grossRevenue2Amount = revenue2;

        this.setState({ form });

        if (dirty === true && this._form !== null)
            FormManager.dirt(this._form);
    }

    get = (vobKey, vobFeinKey, vobNameKey) => {

        var rq = {
            vobKey: vobKey !== undefined ? vobKey : null,
            vobFeinKey: vobFeinKey !== undefined ? vobFeinKey : null,
            vobNameKey: vobNameKey !== undefined ? vobNameKey : null
        };

        API.Certification.get('/certificationSetup/getPreQualification', rq,
            {
                success: (r) => {
                    this.setState((prevState, props) => ({
                        loading: false,
                        form: r.data,
                        tooltips: r.data.tooltips,
                        questionnaire: r.data.questionnaire,
                        previousYear: r.data.grossRevenue1Year,
                        priorToPreviousYear: r.data.grossRevenue2Year,
                        annualSalesTypeList: r.data.annualSalesTypeList,
                    }));
                    this.handleCompanyGrossRevenue1AmountChange();
                    this.setInitialFocus();
                }
            });
    }

    save = (complete) => {
        if (complete && !this._form.validate())
            return;

        if (!this.validateQuestionnaire())
            return;

        const form = this.state.form;
        const me = this;

        let rq = {
            certificationId: form.certificationId,
            vobId: form.vobId,
            annualSalesTypeId: form.annualSalesTypeId,
            questionnaire: me.state.questionnaire,
            grossRevenue1Year: form.grossRevenue1Year,
            grossRevenue1Amount: this.getRevenueNumber(form.grossRevenue1Amount),
            grossRevenue2Year: form.grossRevenue2Year,
            grossRevenue2Amount: this.getRevenueNumber(form.grossRevenue2Amount),
            complete: complete,
            companyName: form.companyName,
            companyFEIN: form.companyFEIN,
            companyWebsite: form.companyWebsite,
            veteranFirstName: form.veteranFirstName,
            veteranLastName: form.veteranLastName,
            mobilePhone: form.mobilePhone ? form.mobilePhone : "",
            veteranEmail: form.veteranEmail,
            majorityOwnerId: form.majorityOwnerId,
            majorityOwnerMobilePhoneId: form.majorityOwnerMobilePhoneId
        };

        API.Certification.post('/certificationSetup/savePreQualification', rq,
            {
                success: (r) => {
                    Notifications.success(r.message);
                    FormManager.reset();

                    if (complete) {
                        this.props.history.push('/certification/preQualificationPayment/' + r.data.vobKey);
                        return;
                    }
                    me.get(r.data.vobKey);
                },
                error: (r) => {
                    if (r.error.errorCode === "ExistingEmail" || r.error.errorCode === "ExistingFein" || r.error.errorCode === "ExistingCompanyName")
                        Modals.alert(r.error.errorMessage);
                    else if (r.data && r.data.rowVersion) {
                        Modals.confirm(r.error.errorMessage,
                            function () {
                                me.save(r.data.rowVersion);
                            },
                            function () {
                                me.get(r.data.vobKey);
                            }
                        );
                    } else {
                        Notifications.error(r.error.errorMessage);
                    }
                }
            });
    }

    onChange = (form, callback) => {
        this.setState({ form }, callback);
    }

    cancel = () => {
        this.props.history.push('/');
    }

    handleAnswerChange = (v, i, j) => {
        let questionnaire = this.state.questionnaire;

        questionnaire.questionCategories[i].questions[j].answer = v;

        this.setState({ ...this.state, questionnaire })

        let question = questionnaire.questionCategories[i].questions[j];

        let servedInCombatQuestion = questionnaire.questionCategories[i].questions
            .filter(x => (x.code === "RQ2"));
        let servedInCombat = servedInCombatQuestion.length === 1 && servedInCombatQuestion[0].answer;

        if ((question.code !== "RQ1" || !servedInCombat) && question.expectedAnswer !== null && question.answer !== question.expectedAnswer) {
            this.setState({ showModal: true, question: question.text })
        }
    }

    validateQuestionnaire = () => {
        let questionnaire = this.state.questionnaire;
        let validate = true;

        loops:
        for (let i = 0; i < questionnaire.questionCategories.length; i++) {
            let category = questionnaire.questionCategories[i];
            
            let servedInCombatQuestion = category.questions
                .filter(x => (x.code === "RQ2"));
            let servedInCombat = servedInCombatQuestion.length === 1 && servedInCombatQuestion[0].answer;

            for (let j = 0; j < category.questions.length; j++) {
                let question = category.questions[j];
                if ((question.code !== "RQ1" || !servedInCombat) && question.expectedAnswer !== null && question.answer !== question.expectedAnswer) {
                    validate = false;
                    this.setState((prevState) => { 
                        return { 
                            showModal: true, 
                            question: question.text
                        }; 
                    });
                    break loops;
                }
            }
        }

        return validate;
    }

    setTip = (property) => {
        const tooltip = this.state.tooltips ? this.state.tooltips.find(t => t.code === property) : undefined
        return tooltip !== undefined ? tooltip.tip : null
    }

    renderQuestionnaire = () => {

        let questionnaire = this.state.questionnaire

        return (
            <React.Fragment>
                {questionnaire &&
                    <React.Fragment>
                        {questionnaire.questionCategories.map((category, i) =>
                            <React.Fragment key={"category" + i}>
                                {category.questions.map((question, j) =>
                                    <Row key={"question" + j}>
                                        <Col xs={9} sm={9} md={9}>
                                            <Label tip={this.setTip(question.code)}>{question.text}</Label>
                                        </Col>
                                        <Col xs={3} sm={3} md={3}>
                                            <FormGroup className="pull-right">
                                                <Switch id={`question-${question.code}`} disabled={question.disabled} value={question.answer} onChange={(v) => this.handleAnswerChange(v, i, j)} labelLeft="No" labelRight="Yes" bsStyle="primary" />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                )}
                            </React.Fragment>

                        )}
                    </React.Fragment>

                }
            </React.Fragment>
        );
    }

    renderModal = () => {
        return (
            <Modal
                show={this.state.showModal}>
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Ineligibility Alert
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p> Your answer to <strong>{this.state.question} question</strong> makes you ineligible at this time. </p>
                    <p> <strong>Select No -</strong> To return to the prequalification questions. </p>
                    <p> <strong>Select Yes -</strong> To terminate this application. </p>
                    <p> For assistance call (888) 237 - 8434 or (586) 983 - 9955 </p>
                    <p> <strong>** No Refunds Beyond This Point **</strong> </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button id="btnCancelModal" bsStyle="success" onClick={this.cancel}>Yes</Button>
                    <Button id="btnCloseModal" onClick={this.closeModal}>No</Button>
                </Modal.Footer>
            </Modal>
        );
    }

    closeModal = () => {
        var me = this;
        me.setState({ showModal: false, question: '' })
    }

    render() {
        const invalidNameTooltip = "Please enter at least 2 chars.";
        const invalidFeinTooltip = "Invalid FEIN / EIN.";
        const invalidAmountTooltip = "Amount must be greater than $0.";
        const invalidUrlTooltip = "Invalid Url.";
        const invalidPhoneTooltip = "Invalid Phone.";
        const invalidEmailTooltip = "Invalid email address.";

        const form = this.state.form;        

        const existingCertification = form.certificationId !== 0 && form.certificationId !== null && form.certificationId !== undefined;
        const existingVob = form.vobId !== 0 && form.vobId !== null && form.vobId !== undefined;
        const disabledForm = (existingCertification && form.certificationTypeCode !== "CER") || (!existingCertification && existingVob);
        const requiredFields = !disabledForm;
        let grossRevenueAmountStyle = null;
        if (disabledForm)
            grossRevenueAmountStyle = { "border" : "2px solid red" };

        let fieldStatus = this.state.fieldStatus;
        if (this.state.loading)
            return null;

        return (
            <React.Fragment>
                {this.renderModal()}
                <Row><Col>&nbsp;</Col></Row>
                <Row>
                    <Col md={4}></Col>
                    <Col className="col-xs-1-10 text-center">
                        <p style={{ fontSize: '13px' }}>
                            <strong>Pre-Qualification</strong>
                        </p>
                        {this.state.form.certificationStatusCode === 'STR' ?
                            <React.Fragment>
                                <FontAwesomeIcon icon={['fas', 'check']} size="3x" style={{ color: '#FF9900' }} className="my-icon" />
                                <p style={{ fontSize: '13px' }}>
                                    <strong>In Progress</strong>
                                </p>
                            </React.Fragment>
                            : this.state.form.certificationStatusCode === 'PRE' ?
                                <React.Fragment>
                                    <FontAwesomeIcon icon={['fas', 'check']} size="3x" style={{ color: '#2A77E4' }} className="my-icon" />
                                    <p style={{ fontSize: '13px' }}>
                                        <strong>Completed</strong>
                                    </p>
                                </React.Fragment>
                                :
                                <React.Fragment>
                                    <FontAwesomeIcon icon={['fas', 'check']} size="3x" style={{ color: 'darkslategray' }} className="my-icon" />
                                    <p style={{ fontSize: '13px' }}>
                                        <strong>Not Started</strong>
                                    </p>
                                </React.Fragment>
                        }
                    </Col>
                    <Col md={2}></Col>
                    <Col className="col-xs-1-10 text-center">
                        <p style={{ fontSize: '13px' }}>
                            Payment
                        </p>
                        <FontAwesomeIcon icon={['fas', 'credit-card']} size="3x" style={{ color: 'darkslategray' }} />
                        <p style={{ fontSize: '13px' }}>
                            Not Started
                            </p>
                    </Col>
                    <Col md={4}></Col>
                </Row>
                <Form
                    onChange={this.updatePostData}
                    values={this.state.form}
                    ref={(c) => { this._form = c }}>
                    <div>
                        <TextBox className="hidden" name="annualSalesTypeId" ref={(c) => { this._annualSalesTypeId = c }} />
                        <ContentBody>
                            <Row>
                                <Col md={12}>
                                    <Box>
                                        <Row>
                                            <Col md={12} lg={2}></Col>
                                            <Col md={12} lg={8}>
                                                <Row>
                                                    <Col sm={12}>
                                                        <h3 style={{ color: '#5592b6' }}>Company Information</h3>
                                                        <hr />
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col xs={11} md={11} lg={5} style={{ paddingRight: 0 }}>
                                                        <FormGroup>
                                                            <Label required={requiredFields} htmlFor="companyName" tip={this.setTip(TooltipCode.REGISTRATION.COMPANY_NAME)}>Company Name</Label>
                                                            <TextBox
                                                                id="companyName"
                                                                required={requiredFields}
                                                                name="companyName"
                                                                placeholder="Enter your Company Name"
                                                                maxLength={128}
                                                                disabled={disabledForm}
                                                                onBlur={this.checkFieldStatus}
                                                                ref={(c) => { this.companyName = c }} />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col xs={1} md={1} lg={1} style={{ paddingLeft: 5 }}>
                                                        { this.renderFieldStatus(fieldStatus.companyNameOk, invalidNameTooltip) }
                                                    </Col>
                                                    <Col xs={11} md={11} lg={5} style={{ paddingRight: 0 }}>
                                                        <FormGroup>
                                                            <Label required={requiredFields} htmlFor="companyFEIN" tip={this.setTip(TooltipCode.REGISTRATION.COMPANY_FEIN)}>FEIN / EIN</Label>
                                                            <MaskedBox
                                                                id="companyFEIN"
                                                                required={requiredFields}
                                                                name="companyFEIN"
                                                                placeholder="Enter your FEIN / EIN"
                                                                mask="99-9999999"
                                                                alwaysShowMask={false}
                                                                maskChar=""
                                                                disabled={disabledForm}
                                                                onBlur={this.checkFieldStatus}
                                                                ref={(c) => { this.companyFEIN = c; }} />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col xs={1} md={1} lg={1} style={{ paddingLeft: 5 }}>
                                                        { this.renderFieldStatus(fieldStatus.companyFEINOk, invalidFeinTooltip) }
                                                    </Col>
                                                </Row>
                                                <Row style={ grossRevenueAmountStyle }>
                                                    <Col xs={11} md={11} lg={5} style={{ paddingRight: 0 }}>
                                                        <FormGroup>
                                                            <Label required htmlFor="grossRevenue1Amount" tip={this.setTip(TooltipCode.REGISTRATION.COMPANY_PREVIOUS_YEAR_AMOUNT)}>{this.state.previousYear} Gross Revenue Amount</Label>
                                                            <CurrencyBox
                                                                id="grossRevenue1Amount"
                                                                required
                                                                name="grossRevenue1Amount"
                                                                positiveNumbersOnly
                                                                placeholder='Enter the Revenue Amount'
                                                                maxLength={15}
                                                                precision={0}
                                                                onBlur={(v) => this.handleCompanyGrossRevenue1AmountChange(v)}
                                                                ref={(c) => { this._companyGrossRevenue1Amount = c; }} />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col xs={1} md={1} lg={1} style={{ paddingLeft: 5 }}>
                                                        { this.renderFieldStatus(fieldStatus.companyGrossRevenue1AmountOk, invalidAmountTooltip) }
                                                    </Col>
                                                    <Col xs={11} md={11} lg={5} style={{ paddingRight: 0 }}>
                                                        <FormGroup>
                                                            <Label required htmlFor="grossRevenue2Amount" tip={this.setTip(TooltipCode.REGISTRATION.COMPANY_PRIOR_TO_PREVIOUS_YEAR_AMOUNT)}>{this.state.priorToPreviousYear} Gross Revenue Amount</Label>
                                                            <CurrencyBox
                                                                id="grossRevenue2Amount"
                                                                required
                                                                name="grossRevenue2Amount"
                                                                positiveNumbersOnly
                                                                placeholder='Enter the Revenue Amount'
                                                                maxLength={15}
                                                                precision={0}
                                                                onBlur={this.checkFieldStatus} />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col xs={1} md={1} lg={1} style={{ paddingLeft: 5 }}>
                                                        { this.renderFieldStatus(fieldStatus.companyGrossRevenue2AmountOk, invalidAmountTooltip) }
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col xs={11} md={11} lg={11} style={{ paddingRight: 0 }}>
                                                        <FormGroup>
                                                            <Label htmlFor="companyWebsite" tip={this.setTip(TooltipCode.REGISTRATION.COMPANY_WEBSITE)}>Company Website</Label>
                                                            <UrlBox
                                                                name='companyWebsite'
                                                                placeholder='Enter your Company Website'
                                                                maxLength={200}
                                                                disabled={disabledForm}
                                                                clickable={false}
                                                                onBlur={this.checkFieldStatus}
                                                                ref={(c) => { this._companyWebsite = c; }} 
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col xs={1} md={1} lg={1} style={{ paddingLeft: 5 }}>
                                                        { this.renderFieldStatus(fieldStatus.companyWebsiteOk, invalidUrlTooltip) }
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col sm={12}>
                                                        <br />
                                                        <h3 style={{ color: '#5592b6' }}>Veteran Information</h3>
                                                        <hr />
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col xs={11} md={11} lg={5} style={{ paddingRight: 0 }}>
                                                        <FormGroup>
                                                            <Label required={requiredFields || form.originalVeteranFirstNameEmpty} htmlFor="veteranFirstName" tip={this.setTip(TooltipCode.REGISTRATION.VETERAN_FIRST_NAME)}>Veteran First Name</Label>
                                                            <TextBox
                                                                id="veteranFirstName"
                                                                required={requiredFields || form.originalVeteranFirstNameEmpty}
                                                                name="veteranFirstName"
                                                                placeholder="Enter your First Name"
                                                                disabled={disabledForm && !form.originalVeteranFirstNameEmpty}
                                                                onBlur={this.checkFieldStatus}
                                                                ref={(c) => { this.firstName = c; }} />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col xs={1} md={1} lg={1} style={{ paddingLeft: 5 }}>
                                                        { this.renderFieldStatus(fieldStatus.veteranFirstNameOk, invalidNameTooltip) }
                                                    </Col>
                                                    <Col xs={11} md={11} lg={5} style={{ paddingRight: 0 }}>
                                                        <FormGroup>
                                                            <Label required={requiredFields || form.originalVeteranLastNameEmpty} htmlFor="veteranLastName" tip={this.setTip(TooltipCode.REGISTRATION.VETERAN_LAST_NAME)}>Veteran Last Name</Label>
                                                            <TextBox
                                                                id="veteranLastName"
                                                                required={requiredFields || form.originalVeteranLastNameEmpty}
                                                                name="veteranLastName"
                                                                placeholder="Enter your Last Name"
                                                                disabled={disabledForm && !form.originalVeteranLastNameEmpty}
                                                                onBlur={this.checkFieldStatus}
                                                                ref={(c) => { this.lastName = c; }} />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col xs={1} md={1} lg={1} style={{ paddingLeft: 5 }}>
                                                        { this.renderFieldStatus(fieldStatus.veteranLastNameOk, invalidNameTooltip) }
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col xs={11} md={11} lg={5} style={{ paddingRight: 0 }}>
                                                        <FormGroup>
                                                            <Label required={requiredFields || form.originalVeteranEmailEmpty} htmlFor="veteranEmail" tip={this.setTip(TooltipCode.REGISTRATION.VETERAN_EMAIL)}>Veteran Email Address</Label>
                                                            <EmailBox
                                                                id="veteranEmail"
                                                                required={requiredFields || form.originalVeteranEmailEmpty}
                                                                name="veteranEmail"
                                                                placeholder="Enter your Veteran Email Address"
                                                                disabled={disabledForm && !form.originalVeteranEmailEmpty}
                                                                onBlur={this.checkFieldStatus}
                                                                ref={(c) => { this._veteranEmail = c; }} />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col xs={1} md={1} lg={1} style={{ paddingLeft: 5 }}>
                                                        { this.renderFieldStatus(fieldStatus.veteranEmailOk, invalidEmailTooltip) }
                                                    </Col>
                                                    <Col xs={11} md={11} lg={5} style={{ paddingRight: 0 }}>
                                                        <FormGroup>
                                                            <Label required={requiredFields || form.originalVeteranMobilePhoneEmpty} htmlFor="mobilePhone" tip={this.setTip(TooltipCode.REGISTRATION.VETERAN_CELL_PHONE)}>Cell Phone</Label>
                                                            <div className="form-inline">
																<PhoneBox
																	id="mobilePhone"
																	required={requiredFields || form.originalVeteranMobilePhoneEmpty}
																	name="mobilePhone"
																	placeholder="Enter your Cell Phone" 
																	types={["Mobile"]}
																	disabled={disabledForm && !form.originalVeteranMobilePhoneEmpty}
																	onBlur={this.checkFieldStatus}
																	ref={(c) => { this._mobilePhone = c; }} />
															</div>
                                                        </FormGroup>
                                                    </Col>
                                                    <Col xs={1} md={1} lg={1} style={{ paddingLeft: 5 }}>
                                                        { this.renderFieldStatus(fieldStatus.mobilePhoneOk, invalidPhoneTooltip) }
                                                    </Col>
                                                </Row>
                                                <Row><Col>&nbsp;</Col></Row>
                                                <Row>
                                                    <Col xs={11} md={11} lg={11} style={{ paddingRight: 0 }}>
                                                        {this.renderQuestionnaire()}
                                                    </Col>
                                                </Row>
                                                {this.renderFee()}
                                            </Col>
                                        </Row>
                                        <Row><Col>&nbsp;</Col></Row>
                                        <Row className="text-right">
                                            <Col md={12}>
                                                <Button type="button" id="btnCancel" title="Cancel" bsStyle="danger"
                                                    onClick={() => this.cancel()}>
                                                    Cancel
                                                </Button>
                                                &nbsp;&nbsp;
                                                <Button type="button" id="btnSave" title="Save" bsStyle="primary"
                                                    onClick={() => this.save(false)}>
                                                    Save
                                                </Button>
                                                &nbsp;&nbsp;
                                                <Button type="button" id="btnNext" title="Next step" bsStyle="success"
                                                    onClick={() => this.save(true)}>
                                                    Continue and PAY
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Box>
                                </Col>
                            </Row>
                        </ContentBody>
                    </div>
                </Form>
            </React.Fragment>
        )
    }
}

export default PreQualification;



// WEBPACK FOOTER //
// ./src/areas/certification/preQualification/PreQualification.js